import React from "react";
import { blogPosts } from "./blogData";
import { Link } from "react-router-dom";
import "./blogIndex.css";

const pillars = [
  "Market Data",
  "Neighborhoods",
  "Landlords",
  "Tenants",
  "Legal & Taxes",
];

export default function BlogIndex() {
  return (
    <div className="blog-index">
      <h1>Rental Highway Blog</h1>
      <p>Insights, guides, and news about property rentals in Nepal.</p>
      <div className="blog-pillars">
        {pillars.map((pillar) => (
          <Link
            key={pillar}
            to={`/blog/pillar/${pillar.toLowerCase().replace(/ & | /g, "-")}`}
          >
            {pillar}
          </Link>
        ))}
      </div>
      {pillars.map((pillar) => {
        const posts = blogPosts.filter((post) => post.pillar === pillar);
        if (posts.length === 0) return null;
        return (
          <section key={pillar} className="blog-pillar-section">
            <ul className="blog-list">
              {posts.map((post) => (
                <li key={post.slug}>
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  <div className="blog-meta">
                    {post.date} | {post.author} | {post.pillar}
                  </div>
                  <div className="blog-desc">{post.metaDescription}</div>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
}
